module.exports = __webpack_public_path__ + "static/media/hp_13.78960b51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/JPEG/hp_13.jpg
// module id = 5824
// module chunks = 0